var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-admin',[_c('admin-crop-grid',{attrs:{"title":_vm.title,"rows":_vm.data,"cols":_vm.cols,"row-href":_vm.rowHref,"defaultOrderByAscending":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }